import { USER_NAME_MAX_LENGTH } from '~/utils/constants/profile';
import { useWeb3ModalAccount } from '@web3modal/ethers/vue';
import type { IUserModel } from '~/types/apiService';

export default () => {
  const { address } = useWeb3ModalAccount();
  const { data: userData } = useNuxtData<IUserModel>('userData');

  const name = computed(() => {
    if (address.value && userData.value?.user?.name && userData.value.user.name.length > USER_NAME_MAX_LENGTH) {
      return formatAddress(address.value);
    }

    return userData.value?.user.name || '';
  });

  return {
    name
  };
};
